<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/emp/skill/authorization/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, '40%')" type="primary" v-if="utils.checkPower('web_employment_management_employee_create')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button @click="yt.showEditDialog('bianji', scope.row, 'w1')" type="text">{{ $t('bianji') }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/emp/skill/authorization/delete')" v-if="utils.checkPower('web_employment_management_employee_skillAuthorizationDelete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>

      <template #zhuangtai="{row}">
        {{ status(row) }}
      </template>
    </yi_curd_table>

    <el-dialog :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" width="50%" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form ref="form" label-width="auto" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item label="工号">
                {{ employee.jobNo }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名">
                {{ employee.name }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="授予技能" required>
                <el-select v-model="formData.skillId" :placeholder="$t('qingxuanze')" size="mini" @change="getSkill" filterable clearable>
                  <el-option v-for="item in skillList" :key="item.id" :label="item.skillNo + '|' + item.skillName" :value="item.id">
                    <span style="float: left">{{ item.skillNo }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.skillName }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('jinengdengji')">
                <yi_dictionary_select :max="1" type="EMPLOYEE_SKILL_LEVEL" :ids.sync="formData.skillLevel"></yi_dictionary_select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="有效日期从" required>
                <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" type="datetimerange" ref="yiTime" :start.sync="formData.authDateFrom" :end.sync="formData.authDateTo"> </yi_time_input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <!-- <span class="days-count">共 {{ dateDifference }} 天</span> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="saveData()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'bianji'">
        <el-form ref="form" label-width="auto" size="mini">
          <el-row>
            <el-col :span="12">
              <el-form-item label="工号">
                {{ employee.jobNo }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="姓名">
                {{ employee.name }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="授予技能">
                {{ yt.editObj.skill.skillName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('jinengdengji')">
                <yi_dictionary_select :max="1" type="EMPLOYEE_SKILL_LEVEL" :ids.sync="yt.editObj.skillLevel"></yi_dictionary_select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="终止日期" required>
                <el-date-picker v-model="yt.editObj.authDateTo" type="datetime" placeholder="选择日期时间"> </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="close">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="update()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
const date = new Date();

export default {
  name: 'certification_table',
  computed: {
    dateDifference() {
      if (this.formData.authDateFrom && this.formData.authDateTo) {
        const start = new Date(this.formData.authDateFrom);
        const end = new Date(this.formData.authDateTo);
        const diffTime = Math.abs(end - start);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      }
      return 0;
    }
  },
  props: {
    employee: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formData: {
        empId: this.employee == null ? '' : this.employee.id,
        authDateFrom: date.getTime(),
        authDateTo: date.getTime()
      },

      skillList: [],
      columns: [
        {
          label: 'jinengbianhao',
          prop: 'skill.skillNo'
        },
        {
          label: 'jinengmingcheng',
          prop: 'skill.skillName'
        },
        {
          label: 'jinengfenlei',
          prop: 'skill.skillType',
          type: 'dictionary',
          key: 'HR_SKILL_TYPE'
        },
        {
          label: 'renzhengriqi',
          prop: 'authDateFrom',
          type: 'time'
        },
        {
          label: 'youxiaoqizhi',
          prop: 'authDateTo',
          type: 'time'
        },
        {
          label: 'zhuangtai',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      //查询技能列表
      this.http.get('/web/skill/page', { params: { pageSize: 10000, empId: this.employee.id } }).then(res => {
        this.skillList = res.data.rows;
      });
      this.formData.authDateFrom = new Date().getTime();
      this.formData.authDateTo = new Date().getTime();
      this.yt.conditions.empId = this.employee.id;
      this.yt.get(1);
    }, 300);
  },
  methods: {
    status(row) {
      return row.authDateTo > date ? '有效' : '无效';
    },

    getSkill(skillId) {
      this.http.get('/web/skill/page', { params: { pageSize: 1, id: skillId } }).then(res => {
        let skill = res.data.rows[0];
        if (skill) {
          let defaultAuthDay = skill.defaultAuthDay ? skill.defaultAuthDay : 0;
          //defaultAuthDay是月份, 当前时间+defaultAuthDay，然后转换为时间戳即可
          this.formData.authDateTo = new Date().getMonth() + (defaultAuthDay * 24 * 3600 * 1000);
          // 计算时间范围
          let start = new Date();
          let end = new Date();
          end.setMonth(end.getMonth() + defaultAuthDay);
          this.formData.authDateFrom = start.getTime();
          this.formData.authDateTo = end.getTime();
          // defaultAuthDay = defaultAuthDay * 24 * 3600 * 1000;
          // this.formData.authDateTo = this.formData.authDateFrom + defaultAuthDay;
          // this.formData.authDateTo = this.formData.authDateFrom + defaultAuthDay * 24 * 3600 * 1000;
        }
      });
    },

    update() {
      this.http
        .post('/web/emp/skill/authorization/update', this.yt.editObj)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.formData = JSON.parse(JSON.stringify({}));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    saveData() {
      this.http
        .post('/web/emp/skill/authorization/create', this.formData)
        .then(res => {
          this.utils.successMessage(this.$t('success'));
          this.yt.isShowEditDialog = false;
          this.formData = JSON.parse(JSON.stringify({}));
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    close() {
      this.yt.isShowEditDialog = false;
      this.formData = { empId: this.employee == null ? '' : this.employee.id, authDateFrom: date.getTime(), authDateTo: date.getTime() };
    }
  }
};
</script>

<style scoped lang="scss">
.skill-authorization {
  padding: 20px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.el-form-item {
  margin-bottom: 20px;
}
.days-count {
  color: red;
  margin-left: 10px;
}
</style>
